import { supabase } from '@/lib/supabase';
import type { ActivityLogEntry } from '@/types/db';

export async function logActivity(action: string, detail?: string): Promise<void> {
  // Fire-and-forget; never block the UI on logging.
  const { error } = await supabase.from('activity_log').insert({ action, detail: detail ?? null });
  if (error) console.warn('activity_log failed:', error.message);
}

export async function getActivity(limit = 50): Promise<ActivityLogEntry[]> {
  const { data, error } = await supabase
    .from('activity_log')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) throw error;
  return data ?? [];
}
